// src/components/LayoutManager.js
import React from 'react';
import { useSelector } from 'react-redux';
import { Box } from '@mui/material';
import SiteNavBar from './SiteNavBar';

const LayoutManager = ({ children }) => {
  const { user } = useSelector((state) => state.auth);

  if (user) {
    return (
      <Box sx={{ 
        display: 'flex', 
        minHeight: '100vh',
        height: '100vh',
        overflow: 'hidden'
      }}>
        <Box sx={{
          width: 240,
          flexShrink: 0,
          position: 'fixed',
          left: 0,
          top: 0,
          bottom: 0
        }}>
          <SiteNavBar />
        </Box>
        <Box sx={{ 
          flexGrow: 1,
          paddingLeft: '240px',
          overflowY: 'auto',
          height: '100vh',
        }}>
          {children}
        </Box>
      </Box>
    );
  }

  return <Box className="main-content">{children}</Box>;
};

export default LayoutManager;